import React, { FC } from "react";
import { I18N_NAMESPACE } from "@/config/i18n";
import { useTranslations } from "next-intl";

type PromotionDescriptionProps = {
  content: string;
  termsAndConditions?: string | null;
};

const PromotionDescription: FC<PromotionDescriptionProps> = ({
  content,
  termsAndConditions = null,
}) => {
  const t = useTranslations(I18N_NAMESPACE.PROMOTIONS);
  return (
    <div className="flex flex-col gap-6 md:gap-10">
      {content && (
        <div
          dangerouslySetInnerHTML={{ __html: content }}
          className="prose max-w-none dark:prose-invert"
        />
      )}
      {/* <div>
        {termsAndConditions && (
          <div
            className="flex items-center justify-between w-full p-4 py-2 text-sm rounded cursor-pointer bg-tertiary-700"
            onClick={() => setShowTerms(!showTerms)}
          >
            {t("promotions-terms-and-conditions")}
            <span className="text-lg">+</span>
          </div>
        )}
        {termsAndConditions && (
          <Transition show={showTerms}>
            <div
              dangerouslySetInnerHTML={{ __html: termsAndConditions }}
              className="prose-sm p-2 prose prose-invert opacity-60 max-w-none"
            />
          </Transition>
        )}
      </div> */}
    </div>
  );
};

export default PromotionDescription;
